import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../../shared/services/logging';
import { InvoiceAddressType } from './invoice-address-type.model';
import { EfaactDataService } from '../../../efaact.data-service';

export const entityName = 'AddressType';
@Injectable({ providedIn: 'root' })
export class InvoiceAddressTypeDataService extends EfaactDataService<InvoiceAddressType> {
    mapItems(item: InvoiceAddressType): InvoiceAddressType {
        return {
            id: item.Addresstype,
            ...item
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
